export const zIndex = {
  hide: { value: -1 },
  auto: { value: 'auto' },
  base: { value: 0 },
  docked: { value: 10 },
  sticky: { value: 1100 },
  sticky1: { value: 1101 },
  sticky2: { value: 1102 },
  popover: { value: 1150 },
  banner: { value: 1200 },
  overlay: { value: 1300 },
  modal: { value: 1400 },
  modal2: { value: 14001 },
  tooltip: { value: 1550 }, // otherwise tooltips will not be visible in modals
  tooltip2: { value: 1551 }, // for tooltips in tooltips
  toast: { value: 1700 },
};

export default zIndex;
